<mdk-modal
  id="{{ identifier }}"
  title="Prikcampagne verwijderen"
  [closable]="false"
>
  <ng-container button>
    <button
      #deleteConfirmationSurveyCampaignOpenButton
      id="delete-survey-campaign-toggle-modal-button"
      class="mdk-modal__hidden-toggle-button"
      [attr.data-vl-modal-open]="identifier"
      title="Modal voor campagne-verwijderen openen"
    ></button>
  </ng-container>
  <ng-container body>
    <div
      class="vl-modal-dialog__content"
      id="modal-{{ identifier }}-description"
    >
      <p>Ben je zeker dat je de campagne wilt verwijderen?</p>
    </div>
    <div class="vl-modal-dialog__footer">
      <div class="vl-action-group">
        <button
          id="delete-survey-campaign-confirmation-button"
          class="vl-button vl-button--icon-before"
          vl-button
          (click)="onClickConfirmDelete()"
          title="Bevestig het verwijderen van de campagne"
        >
          <i
            class="vl-button__icon vl-button__icon--before vl-vi vl-vi-bin"
            aria-hidden="true"
          ></i>
          <span class="vl-button__label">Campagne verwijderen</span>
        </button>
        <a
          id="close-button"
          class="vl-link"
          data-vl-modal-close
          #deleteConfirmationSurveyCampaignCloseButton
        >
          <span
            class="vl-link__icon vl-link__icon--before vl-vi vl-vi-cross"
            aria-hidden="true"
          ></span
          >Annuleer
        </a>
      </div>
    </div>
  </ng-container>
</mdk-modal>
